module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter"
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I awoke in excruciating pain, unable to tell where it began or ended. Every bone was broken, every ligament torn, every internal organ wrenched out of place. Everything—everything—smashed beyond repair. The thin envelope of skin was pierced in a hundred places, the blood pulsing out to seep into the cold damp ground.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bitch!")]), _vm._v(" The venomous hatred in the explosive whisper seared my eardrums, bringing more pain. Who hated me that much?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I forced my eyes open and for a brief hallucinatory moment I saw a wall of earth, felt a trickle of icy water beneath me, was aware of the ivy-clad tower of an ancient building looming into the dark sky above me …")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No … not me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The vision began to fade. I closed my eyes and opened them again. I was lying in bed in a Melbourne hotel at the end of a hugely successful Australian tour. I was safe, warm, comfortable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pain was retreating into just a memory of pain, the last residue of an exceptionally vivid nightmare.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Or was it?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Panic was surging in to replace the earlier sensations. Panic—and a dark foreboding.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a strange thing being a twin, sometimes we each seemed one-half of a whole. Blood of my blood, bone of my bone, the tie was stronger in a way than mere direct lineage, than even the parent—child relationship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It meant that there was always someone there, a mind "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v(" that meshed with your own. Someone to laugh with, share secrets with, always there, with reactions identical to your own. It meant you were never alone, in the way other people were.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a privileged life that carried with it a secret dread: by the very nature of life, of mortality, it could not go on for ever. Some day one or the other of us would have to pay.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No! It had just been a nightmare. It was something I ate. It wasn’t true.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tried to keep fighting as the swirling vortex carried me down into sleep—or unconsciousness—but, deep down, I knew.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Something terrible had just happened to Nessa. ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-286980bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Fm1.vue
// module id = 72
// module chunks = 0